// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"8b02fcf8","368":"161a3452","420":"43e1d26f","508":"91499fd9","662":"9c9567a3","666":"594f6a53","720":"3ec54acc","860":"1d776931","940":"d5947199"}[chunkId] + ".chunk.js";
};